import store from '../store';
import api from './api';
import { showLoading, hideLoading } from '../reducers/loading';
import { resetSteps } from '../reducers/steps';
import { updateSubscription, resetSubscription } from '../reducers/subscription';
import { sendError } from './errorTracking';
import { CardNumberElement } from '@stripe/react-stripe-js';

import { createSubscriptionInMoip } from './gateways/moip';
import { createMercadoPagoToken } from './gateways/mercadopago';

import _ from 'lodash';

export const updateReducerAndForm = async (values = {}, setFieldValue) => {
  store.dispatch(updateSubscription(values));

  _.forOwn(values, async (value, key) => {
    await setFieldValue(key, value);
  });
}

export const createStripeToken = async (stripe, elements, setFormErrors) => {
  const cardElement = elements.getElement(CardNumberElement);
  let subscription = store.getState().subscription;
  setFormErrors([]);
  
  const response = await stripe.createToken(cardElement, {
    name: subscription.creditCardHolderName,
    address_line1: `${subscription.street} - ${subscription.number} - ${subscription.complement}`,
    address_line2: subscription.neighborhood,
    address_city: subscription.city,
    address_state: subscription.state,
    address_zip: subscription.zipcode,
    address_country: 'BR'
  });

  if(response.token){
    store.dispatch(updateSubscription({
      stripeToken: response.token.id
    }));
  }
  else {
    sendError('stripeTokenNotCreated', { error: response.error.message });
    store.dispatch(updateSubscription({
      stripeToken: ''
    }));
    setFormErrors([response.error.message]);
  }
}

export const createSubscription = async ({ setFormErrors, stripe, elements }) => {
  if(process.env.REACT_APP_PAYMENT_GATEWAY === 'stripe') {
    await createStripeToken(stripe, elements, setFormErrors);
  }
  else if(process.env.REACT_APP_PAYMENT_GATEWAY === 'mercadopago') {
    await createMercadoPagoToken(setFormErrors);
  }

  let subscription = store.getState().subscription;
  
  const goodToGo = (process.env.REACT_APP_PAYMENT_GATEWAY === 'stripe' && subscription.stripeToken)
    || (process.env.REACT_APP_PAYMENT_GATEWAY === 'mercadopago' && subscription.mercadoPagoToken)
    || process.env.REACT_APP_PAYMENT_GATEWAY === 'moip'

  if(goodToGo){
    sendError('createSubscription');
    setFormErrors([]);

    store.dispatch(showLoading('Criando assinatura...'));

    let params = { ...subscription };
    delete params.creditCardNumber;
    delete params.creditCardCvc;

    api.post('/subscriptions/create', params).then((response) => {
      store.dispatch(hideLoading());

      if(response.data && response.data.success){
        let token = response.data.order_token;
        sendError('subscriptionCreated', { order_token: token });

        if(process.env.REACT_APP_PAYMENT_GATEWAY === 'moip') {
          createSubscriptionInMoip({ setFormErrors }, () => {
            paySubscription({ token, setFormErrors });
          });
        }
        else {
          finishSubscription(response.data.redirect_url);
        }
      }
      else {
        setFormErrors(response.data.errors);
        sendError('subscriptionNotCreated', { errors: response.data.errors });
      }
    }).catch((e) => {
      sendError('ERROR: /subscriptions/create', { message: e.message });
      store.dispatch(hideLoading());
    });
  }
}

export const paySubscription = ({ token, setFormErrors }) => {
  sendError('paySubscription');
  setFormErrors([]);

  store.dispatch(showLoading('Criando assinatura...'));

  api.post('/subscriptions/paid', { token }).then((response) => {
    if(response.data.success){
      sendError('subscriptionPaid');

      finishSubscription(response.data.redirect_url);
    }
    else {
      setFormErrors(response.data.errors);

      sendError('errorPayingSubscription', { errors: response.data.errors });
    }

    store.dispatch(hideLoading());
  }).catch((e) => {
    sendError('ERROR: /subscriptions/paid', { message: e.message });
    store.dispatch(hideLoading());
  });
}

export const finishSubscription = (redirectUrl) => {
  store.dispatch(resetSubscription());
  store.dispatch(resetSteps());

  window.location.href = redirectUrl;
}